import * as yup from 'yup';
import { getRandomKey } from '../../helpers';

export const Schema = (whiteLabelApp) =>  {
  const { name, bundle_id, branding, urls } = whiteLabelApp || {};
  const { android_link, app_link, ios_link, website, web_app_link } = urls || {};
  const { brand_colour, brand_colour_secondary, email_footer } = branding || {};

  return {
    brandingLeft: {
      'Name': {
        defaultValue: name,
        field: 'name',
        key: `${getRandomKey()}-name`,
        validation: yup.string().required(),
      },
      'Bundle ID': {
        defaultValue: bundle_id,
        field: 'bundle_id',
        key: `${getRandomKey()}-bundle_id`,
        validation: yup.string().required(),
      },
      'Primary Colour': {
        defaultValue: brand_colour || '#',
        color: brand_colour,
        key: `${getRandomKey()}-brand_colour`,
        field: 'branding.brand_colour',
        validation: yup.string().matches(/^#(?:[0-9a-f]{3}){1,2}$/i),
      },
      'Secondary Colour': {
        defaultValue: brand_colour_secondary || '#',
        color: brand_colour_secondary,
        key: `${getRandomKey()}-brand_colour_secondary`,
        field: 'branding.brand_colour_secondary',
        validation: yup.string().matches(/^#(?:[0-9a-f]{3}){1,2}$/i).required(),
      },
      'Website': {
        defaultValue: website,
        field: 'urls.website',
        key: `${getRandomKey()}-website`,
        validation: yup.string(),
      },
      'Email Footer Text': {
        defaultValue: email_footer,
        field: 'branding.email_footer',
        key: `${getRandomKey()}-email_footer`,
        validation: yup.string(),
      },
    },
    mobileAppLinksLeft: {
      'iOS App Link': {
        defaultValue: ios_link,
        field: 'urls.ios_link',
        key: `${getRandomKey()}-ios_link`,
        validation: yup.string(),
      },
      'Universal App Link': {
        defaultValue: app_link,
        field: 'urls.app_link',
        key: `${getRandomKey()}-app_link`,
        validation: yup.string(),
      },
      'Android App Link': {
        defaultValue: android_link,
        field: 'urls.android_link',
        key: `${getRandomKey()}-android_link`,
        validation: yup.string(),
      },
      'Web App Link': {
        defaultValue: web_app_link,
        field: 'urls.web_app_link',
        key: `${getRandomKey()}-web_app_link`,
        validation: yup.string(),
      },
    },
  }
};

export const BannerSchema = banner => {
  const { title, link } = banner || {};

  return {
    banners: {
      'Banner Title': {
        defaultValue: title || '',
        field: 'title',
        key: `${getRandomKey()}-title`,
        validation: yup.string().required(),
      },
      'External Link': {
        defaultValue: link|| '',
        field: 'link',
        key: `${getRandomKey()}-link`,
        validation: yup.string().required(),
      },
    },
  };
};
